import React, { useEffect, useState } from 'react';
import { axiosInstance } from '../lib/axio';
import { useParams, useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import "../styles/blogItem.css";

const BlogItem = () => {
    const { slug } = useParams();
    const navigate = useNavigate();  // Initialize the navigate function
    const [blogData, setBlogData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axiosInstance.get(`/blogs/${slug}`);
                if (response.data.success) {
                    setBlogData(response.data.blog);
                } else {
                    setError("Blog not found");
                    navigate(response.data.redirectUrl);  // Redirect to home if the blog is not found
                }
            } catch (error) {
                setError("Error fetching blog: " + error.message);
                navigate('/');  // Redirect to home in case of error
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [slug, navigate]);  // Add navigate to dependency array

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    return (
        <div className="bg-white text-gray-800 font-sans flex flex-col items-center">
            <div className="w-[62vw] flex flex-col items-center blogitem-container-div">
                {/* Date and Title */}
                <div className="text-center py-10 w-[80%] blogitem-div-1">
                    {loading ? (
                        <>
                            <Skeleton width={150} height={20} style={{ marginBottom: '1rem' }} />
                            <Skeleton width="70%" height={40} />
                        </>
                    ) : error ? (
                        <p className="text-red-500">{error}</p>
                    ) : (
                        <>
                            <p className="text-gray-600 text-sm blogitem-date">{formatDate(blogData.date)}</p>
                            <h1 className="text-4xl font-bold text-pink-600 mt-2 blogitem-title">{blogData.title}</h1>
                        </>
                    )}
                </div>

                {/* Image */}
                <div className="w-full flex justify-center blogitem-image-div">
                    {loading ? (
                        <Skeleton width={750} height={750} style={{ borderRadius: '1rem', marginTop: '1rem' }} />
                    ) : error ? null : (
                        <img
                            src={blogData.imageUrl}
                            alt={blogData.title}
                            className="blogitem-image w-full max-w-[700px] h-[800px] rounded-lg object-contain"
                            loading="lazy"
                        />
                    )}
                </div>

                {/* Content */}
                <div className="px-4 sm:px-10 lg:px-20 py-8 leading-relaxed text-lg blogitem-content-div">
                    {loading ? (
                        <Skeleton count={8} height={20} style={{ marginBottom: '1rem' }} />
                    ) : error ? (
                        <p className="text-red-500">{error}</p>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: blogData.content }} />
                        // blogData.content.split('\n').map((paragraph, idx) => (
                        //     <p key={idx} className="mt-4">
                        //         {paragraph}
                        //     </p>
                        // ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default BlogItem;
